import { useForm } from "react-hook-form";
import useEvent from "react-use-event-hook";

import {
  usePageContext,
  usePassengersMapBulkActions,
  useSelectedIds,
  useYupValidationResolver,
} from "@ryde/redux";
import {
  FilterStationFormFieldsEnum,
  PassengerMapStationFilterTypeEnum,
  PASSENGERS_MAP_DEFAULT_FILTER_TYPE,
} from "@ryde/shared";

import { yupFilterStationValidationSchema } from "../validations";

export const usePassengerMapFilterStationPanel = () => {
  const { entity } = usePageContext();
  const { selectedRowsIds } = useSelectedIds(entity);
  const { bulkFetchPassengersStationMapData } = usePassengersMapBulkActions();

  const resolver = useYupValidationResolver(
    yupFilterStationValidationSchema,
    "passenger",
  );

  const methods = useForm<{ filterType: PassengerMapStationFilterTypeEnum }>({
    mode: "all",
    reValidateMode: "onChange",
    criteriaMode: "firstError",
    defaultValues: {
      filterType: PASSENGERS_MAP_DEFAULT_FILTER_TYPE,
    },
    resolver,
  });

  const {
    getValues,
    trigger,
    watch,
    formState: { isValid },
  } = methods;

  const filterStationTypeValue = watch(FilterStationFormFieldsEnum.filterType);

  const isDisabled = !isValid || !filterStationTypeValue;

  const handleChange = useEvent(async (): Promise<void> => {
    const isValidAfterTrigger = await trigger();

    if (!isValidAfterTrigger) {
      return;
    }

    const filterType = getValues(FilterStationFormFieldsEnum.filterType);

    await bulkFetchPassengersStationMapData({
      filterType,
      selectedPassengersIds: selectedRowsIds,
    });
  });

  return { methods, handleChange, isDisabled };
};
